/* * 本页面为库区新增和库区修改界面 * 通过pageType字段来区分：1新增，2修改 * */
<template>
  <div ref="pageView" class="page-view container-view">
    <!-- title -->
    <section class="title-section fixed-view">
      <e6-title>
        {{ pageTitle }}
        <template slot="breadcrumb">
          <e6-breadcrumb :breadcrumbs="breadcrumbs"></e6-breadcrumb>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- content -->
    <section
      class="content-section"
      :style="{ height: resizeViewHeight + 'px' }"
    >
      <div class="form-wrapper">
        <e6-form-extend
          class="e6-from--column-2"
          ref="formExtend"
          :formExtend="formExtend"
          :inline="true"
          label-width="200px"
          :submitLoadingState="loadingState"
          @submitForm="handleSubmitForm"
          @resetForm="handleResetForm"
        >
          <template slot-scope="slotForms">
            <el-form-item
              label="库区名称"
              prop="forms.storageAreaName"
              :rules="[
                {
                  required: true,
                  message: '请输入库区名称',
                  trigger: 'blur',
                },
                { validator: CheckRemarkLength, trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="slotForms.forms.storageAreaName"
                placeholder="库区名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item
              prop="forms.storageAreaType"
              label="库区类型"
              :rules="[
                {
                  required: true,
                  message: '请选择库区类型',
                  trigger: 'change',
                },
              ]"
            >
              <dict-select
                v-model="slotForms.forms.storageAreaType"
                placeholder="库区类型"
                :pkey="'storage_area_type'"
              ></dict-select>
            </el-form-item>
            <el-form-item
              prop="forms.storageId"
              label="所属冷库"
              :rules="[
                {
                  required: true,
                  message: '请选择所属冷库',
                  trigger: 'change',
                },
              ]"
            >
              <el-select
                v-model="slotForms.forms.storageId"
                collapse-tags
                filterable
                placeholder="所属冷库"
              >
                <el-option
                  v-for="item in allStorageInfo"
                  :key="item.storageId"
                  :label="item.storageName"
                  :value="item.storageId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="门数量"
              prop="forms.doorNum"
              :rules="[
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="slotForms.forms.doorNum"
                placeholder="门数量"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.closeForm" label="封闭形式">
              <dict-select
                v-model="slotForms.forms.closeForm"
                placeholder="请选择封闭形式"
                :pkey="'close_form'"
              ></dict-select>
            </el-form-item>
            <el-form-item prop="forms.memoryItemsType" label="存储物品">
              <el-select
                class="sel-select"
                v-model="slotForms.forms.memoryItemsType"
                filterable
                clearable
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in storeItemList"
                  :key="item.dicId"
                  :label="item.dicName"
                  :value="item.dicId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="容积(立方米)"
              prop="forms.volume"
              :rules="[
                { required: true, message: '请输入容积', trigger: 'blur' },
                { validator: validatorIntNum, trigger: 'blur' },
                { validator: CheckNumberLength, trigger: 'blur' },
              ]"
            >
              <el-input
                v-model="slotForms.forms.volume"
                placeholder="容积(立方米)"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item prop="forms.alarmId" label="温湿度标准">
              <el-select
                v-model="slotForms.forms.alarmId"
                filterable
                clearable
                placeholder="请选择温湿度标准"
              >
                <el-option
                  v-for="item in humitureTree"
                  :key="item.alarmId"
                  :label="item.tempAndHumidityStandardName"
                  :value="item.alarmId"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
          <template slot="submit">保存</template>
          <template slot="reset">返回</template>
        </e6-form-extend>
      </div>
    </section>
    <!-- content end -->
  </div>
</template>
``
<script>
import {
  SaveStorageAreaInfo,
  FindStorageAreaInfoById,
  FindStorageAll,
} from "@/api/base/storageArea";

import { FetchHumitureName } from "@/api/systemSetting/humitureStandardSet";

import resizeListener from "_private/mixins/resizeListener";
import {
  CheckRemarkLength,
  CheckPriceOrDistance,
  validatorIntNum,
  CheckNumberLength,
} from "@/utils/validation";
export default {
  mixins: [resizeListener],
  data() {
    return {
      breadcrumbs: [
        {
          path: "/home",
          isRedirect: true,
          meta: {
            title: "首页",
          },
        },
        {
          path: "/baseStorageAreaList",
          isRedirect: true,
          meta: {
            title: "库区基础信息",
          },
        },
      ],
      formExtend: {
        forms: {
          storageAreaName: "",
          storageAreaType: "",
          memoryItemsType: "",
          closeForm: "",
          doorNum: "",
          volume: "",
          storageId: "",
          alarmId: "",
        },
        extends: [],
      },
      storeItemList: [],
      editState: false,
      allStorageInfo: [],
      CheckRemarkLength: CheckRemarkLength,
      CheckPriceOrDistance: CheckPriceOrDistance,
      validatorIntNum: validatorIntNum,
      CheckNumberLength: CheckNumberLength,
      loadingState: false,
      humitureTree: [],
    };
  },
  computed: {
    pageType() {
      return this.$route.query.pageType ? this.$route.query.pageType : "1";
    },
    pageTitle() {
      const pageTitle =
        this.pageType === "1" ? "库区基础信息新增" : "库区基础信息修改";
      return pageTitle;
    },
    id() {
      return this.$route.query.id;
    },
  },
  created() {
    this.FetchHumitureName();
    this.initAllCustomer();
    this.initStoreItemSelect();
    let breadcrumb = {
      path: "/systemSettingDataDictionaryMaintenanceEdit",
      isRedirect: false,
      meta: {
        title: this.pageTitle,
      },
    };
    this.breadcrumbs.push(breadcrumb);
    if (this.pageType !== "1") {
      this.FindStorageAreaInfoById({ storageAreaId: this.id });
      this.editState = true;
    }
  },
  methods: {
    // 获取温湿度标准下拉Tree
    FetchHumitureName() {
      FetchHumitureName()
        .then((response) => {
          if (response.result && Array.isArray(response.result)) {
            this.humitureTree = response.result;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     *  初始化冷库下拉信息
     */
    initAllCustomer() {
      FindStorageAll()
        .then((response) => {
          if (
            response.result &&
            response.result &&
            Array.isArray(response.result)
          ) {
            this.allStorageInfo = response.result;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 储存物品下拉
    initStoreItemSelect() {
      this.$axios
        .post(
          "/base/dictionary/getDictByDicTypeKey",
          this.$qs.stringify({
            dicTypeKey: "store_item",
          })
        )
        .then((e) => {
          if (e.data.code === 1) {
            this.storeItemList = e.data.result;
          } else {
            this.errorMessage(e.data.message, e.data.code);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 修改库区数据时，先获取库区数据信息
    FindStorageAreaInfoById(response) {
      FindStorageAreaInfoById(response)
        .then((response) => {
          this.formExtend.forms = Object.assign({}, response.result);
          if (response.result.memoryItemsType) {
            this.formExtend.forms.memoryItemsType = Number(
              response.result.memoryItemsType
            );
          } else {
            this.formExtend.forms.memoryItemsType = "";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    // 新增，修改库区数据
    SaveStorageAreaInfo(response) {
      SaveStorageAreaInfo(response)
        .then((response) => {
          this.submitCallback(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 新增库区信息完成时的回调函数
    submitCallback(response) {
      let type = response.code === 1 ? "success" : "error";
      let message = response.message;
      this.$message({
        showClose: true,
        message: message,
        type: type,
        duration: 2000,
        onClose: () => {
          if (type === "success") {
            this.$router.push({
              path: "/baseStorageAreaList",
              query: { refreshportion: true },
            });
          }
          this.loadingState = false;
        },
      });
    },
    // 提交
    handleSubmitForm(e) {
      if (e) {
        this.loadingState = true;
        this.SaveStorageAreaInfo(Object.assign({}, this.formExtend.forms));
      }
    },
    // 取消
    handleResetForm() {
      this.$router.push("/baseStorageAreaList");
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-demo {
  width: 300px;
  margin: 10 150px 10px 200px;
}
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 20px 10px;
}
.content-section {
  overflow: auto;
}
.content-section {
  .form-wrapper {
    padding-top: 20px;
    margin: 0 20px;
    background-color: #fff;
  }
}
/deep/.hide .el-upload--picture-card {
  display: none;
}
/deep/ .e6-from--column-2 {
  .el-input {
    width: 300px;
  }
  .el-textarea__inner {
    width: 500px;
  }
}
</style>
